import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CollectionResponse, DynamicReportsModel } from '@core/models';
import { DynamicReportsSidebarState } from '@core/state/admin';
import { environment } from '@env/environment';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicReportsSidebarService {
  constructor(
    private dynamicReportsSidebarState: DynamicReportsSidebarState,
    private httpClient: HttpClient
  ) {}

  public loadReports() {
    const url = `${environment.apiUrl}/v1/admin/reports/dynamic-dashboards`;
    this.httpClient
      .get<CollectionResponse<DynamicReportsModel>>(url, {
        params: { is_active: true },
      })
      .pipe(first())
      .subscribe((response) =>
        this.dynamicReportsSidebarState.addReports(response.data.items)
      );
  }
}
